import { z } from 'zod';

// A LegalEntity is one of our emirate trade licenses. Mirrors the Designation
// CRUD shape: an Input schema for create/update bodies and a full Schema for
// read responses (Input + server-stamped id/timestamps).
export const LegalEntityInputSchema = z.object({
  name: z.string().min(1).max(120),
  emirate: z.string().max(80),
  licenseNo: z.string().max(40).optional().nullable(),
  wpsEstablishmentId: z.string().max(40).optional().nullable(),
  glCode: z.string().max(40).optional().nullable(),
  isActive: z.boolean().default(true),
});
export type LegalEntityInput = z.infer<typeof LegalEntityInputSchema>;

export const LegalEntitySchema = LegalEntityInputSchema.extend({
  id: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type LegalEntity = z.infer<typeof LegalEntitySchema>;
